"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validate = void 0;
function validate(name, handler) {
    if (!handler.endpoint && !handler.space) {
        return `Handler "${name}" should have "endpoint" or "space" property`;
    }
}
exports.validate = validate;
//# sourceMappingURL=validate.js.map